




import { defineComponent, onMounted, ref } from "@vue/composition-api";
import providers, { getManagerProviders } from "@/lib/api";
import { loginToken } from "@/lib/loginHelpers";
import BasePage from "@/components/BasePage";

export default defineComponent({
  name: "PageLoginToken",
  components: { BasePage },
  props: {
    token: { type: String, required: true },
  },
  setup(props, { root }) {
    const loading = ref(false);

    onMounted(async () => {
      try {
        loading.value = true;
        const currentToken = await providers.LoginProvider.getLongLiveToken();

        if (currentToken !== props.token) {
          const managerProviders = getManagerProviders();
          await managerProviders.providers.LoginProvider.setLongLiveToken("");
          managerProviders.apiTools.close();

          await loginToken(props.token);
        }
        root.$router.replace({ name: "home" });
      } finally {
        loading.value = false;
      }
    });

    return { loading };
  },
});
